export const ObjectType = {
  FACTORY: "F",
  VESSEL: "V",
  PORT: "P",
};
